import request from '@/utils/request'

/**
 * 获取全量品牌 https://mock-test.cheweijia.com/project/44/interface/api/500393
 * @param {number} data.modelFilterScene - 过滤场景类型 1:全部车辆车型 2: 筛选未退出运营车辆车型 3: 筛选退出运营车辆车型 4: 筛选租赁方案车型
 * @returns
 */
export function getAllBrand(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/modelV2/getAllBrand',
    method: 'POST',
    data,
  })
}

/**
 * 根据品牌查询车系接口 https://mock-test.cheweijia.com/project/44/interface/api/500395
 * @param {*} data
 * @param {string} data.brandId - 品牌id
 * @param {number} data.modelFilterScene - 过滤场景类型 1:全部车辆车型 2: 筛选未退出运营车辆车型 3: 筛选退出运营车辆车型 4: 筛选租赁方案车型
 * @returns
 */
export function getSeriesListByBrand(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/modelV2/getSeriesListByBrand',
    method: 'POST',
    data,
  })
}

/**
 * 车型列表分页 https://mock-test.cheweijia.com/project/44/interface/api/500397
 * @param {*} data
 * @param {number} data.pageNum
 * @param {number} data.pageSize
 * @param {number} data.brandId - 品牌id
 * @param {number} data.seriesId - 车系id
 * @param {string} data.modelYear - 年款
 * @param {number} data.operationType - 运营类型
 * @param {number} data.energyType - 能源类型
 * @param {number} data.state - 状态（0禁用   1启用）
 * @returns
 */
export function getPageModel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/modelV2/getPageModel',
    method: 'POST',
    data,
  })
}

/**
 * 车型详情 https://mock-test.cheweijia.com/project/44/interface/api/500399
 * @param {*} data
 * @param {number} data.modelId - 车型ID
 * @returns
 */
export function getModelDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/modelV2/getModelDetail',
    method: 'POST',
    data,
  })
}

/**
 * 根据车系查询车型列表 https://mock-test.cheweijia.com/project/44/interface/api/500401
 * @param {*} data
 * @param {number} data.seriesId - 车系ID
 * @param {number} data.modelFilterScene - 过滤场景类型 1:全部车辆车型 2: 筛选未退出运营车辆车型 3: 筛选退出运营车辆车型 4: 筛选租赁方案车型
 * @returns
 */
export function getModelsBySeriesId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/modelV2/getModelsBySeriesId',
    method: 'POST',
    data,
  })
}

/**
 * 根据名称模糊查询品牌车系
 * @param {*} data
 * @param {string} data.brandOrSeriesName - 品牌或车系名称
 * @param {number} data.modelFilterScene - 过滤场景类型 1:全部车辆车型 2: 筛选未退出运营车辆车型 3: 筛选退出运营车辆车型 4: 筛选租赁方案车型
 * @returns
 */
export function queryBrandAndSeriesByName(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/modelV2/queryBrandAndSeriesByName',
    method: 'post',
    data,
  })
}

